import PropTypes from 'prop-types'

export const additionalInfoProps = PropTypes.shape({
    associationName: PropTypes.string.isRequired,
    sectorId: PropTypes.number.isRequired
})
